// Create a history of your choosing (we're using a browser history in this case)
import createHistory from 'history/createBrowserHistory';

const history = createHistory();

export default history;

